import React from 'react'
import { useParams } from 'react-router-dom'
import { Loader } from '@crossfit/ui'

import { useDailyClassPlan } from '../hooks'
import Navigation from './Navigation'
import AffiliateDailyClassPlan from './Affiliate'
import AtHomeDailyClassPlan from './AtHome'
import CompeteDailyClassPlan from './Compete'
import LiftingDailyClassPlan from './Lifting'
import usePageTitle from 'hooks/usePageTitle'
import { ProgrammingTrack } from '../types'

function DailyClassPlanPage() {
  const { date, track } = useParams()
  const { data, isLoading, isError } = useDailyClassPlan(track, date)

  usePageTitle(
    `CrossFit Affiliate Toolkit${data?.name ? ` | ${data.name}` : ''}`,
  )

  if (isError) {
    return <div>Oops!</div>
  }

  if (isLoading) {
    return <Loader />
  }

  return (
    <>
      <Navigation slugs={data.slugs} date={data.date} />

      {data.track === ProgrammingTrack.AffiliateTrack && (
        <AffiliateDailyClassPlan classPlan={data} />
      )}

      {data.track === ProgrammingTrack.AtHomeTrack && (
        <AtHomeDailyClassPlan classPlan={data} />
      )}

      {data.track === ProgrammingTrack.CompeteTrack && (
        <CompeteDailyClassPlan classPlan={data} />
      )}

      {data.track === ProgrammingTrack.LiftingTrack && (
        <LiftingDailyClassPlan classPlan={data} />
      )}
    </>
  )
}

export default DailyClassPlanPage
